export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10495.5ebe6014.jpg";